import { BellRing, X } from 'lucide-react';
import { Badge } from '@waymail/ui';
import {
  useAbrirAcompanhado,
  useCancelarLembrete,
  useLembretes,
  descreverVencimento,
} from '../lib/lembretes';

/**
 * "Acompanhar" (WYM-15, ADR 0061): lembretes pendentes e vencidos, e as
 * enviadas que aguardam resposta com ha quantos dias. Resposta detectada tira o
 * lembrete daqui sozinha; cancelar so apaga o lembrete, nunca a mensagem.
 */
export function Acompanhamento() {
  const lembretes = useLembretes();
  const cancelar = useCancelarLembrete();
  const abrir = useAbrirAcompanhado();

  const itens = lembretes.data?.items ?? [];
  const aguardando = lembretes.data?.awaiting ?? [];
  if (itens.length === 0 && aguardando.length === 0) return null;
  const vencidos = itens.filter((i) => i.status === 'fired').length;

  return (
    <section aria-label="Acompanhar" className="mt-5">
      <p className="flex items-center gap-1.5 px-2.5 text-[12px] font-semibold text-secondary">
        <BellRing size={14} strokeWidth={1.5} aria-hidden="true" />
        Acompanhar
        {vencidos > 0 && (
          <Badge tone="red" aria-label={`${vencidos} vencidos`}>
            {vencidos}
          </Badge>
        )}
      </p>

      <ul className="mt-1 flex flex-col gap-0.5">
        {itens.map((i) => (
          <li key={i.id} className="relative flex items-center">
            <button
              type="button"
              onClick={() => void abrir(i.accountId, i.messageId)}
              className="flex h-9 w-full min-w-0 cursor-pointer flex-col justify-center rounded-lg px-2.5 pr-9 text-left hover:bg-hover"
            >
              <span className="truncate text-[13px] font-semibold text-primary">{i.subject}</span>
              <span className="truncate text-[11px] text-secondary">
                {i.status === 'fired'
                  ? 'Vencido, sem resposta'
                  : `Em ${descreverVencimento(i.dueAt, i.timezone)}`}
              </span>
            </button>
            <button
              type="button"
              aria-label={`Cancelar lembrete de ${i.subject}`}
              title="Cancelar lembrete"
              disabled={cancelar.isPending}
              onClick={() => cancelar.mutate(i.id)}
              className="absolute right-1 flex size-7 cursor-pointer items-center justify-center rounded-md text-tertiary hover:bg-hover hover:text-primary"
            >
              <X size={16} strokeWidth={1.5} aria-hidden="true" />
            </button>
          </li>
        ))}
      </ul>

      {aguardando.length > 0 && (
        <>
          <p className="px-2.5 pt-3 pb-1 text-[12px] font-semibold text-secondary">
            Aguardando resposta
          </p>
          <ul className="flex flex-col gap-0.5">
            {aguardando.slice(0, 10).map((a) => (
              <li key={a.messageId}>
                <button
                  type="button"
                  onClick={() => void abrir(a.accountId, a.messageId)}
                  className="flex h-9 w-full min-w-0 cursor-pointer flex-col justify-center rounded-lg px-2.5 text-left hover:bg-hover"
                >
                  <span className="truncate text-[13px] font-semibold text-primary">
                    {a.subject}
                  </span>
                  <span className="text-[11px] text-secondary">
                    {a.days === 0
                      ? 'Enviada hoje'
                      : `Há ${a.days} ${a.days === 1 ? 'dia' : 'dias'}`}
                  </span>
                </button>
              </li>
            ))}
          </ul>
        </>
      )}
    </section>
  );
}
